export enum UserPermissionsFilterTypes {
  UserRoles = "UserRoles",
}
